import $ from 'jquery';

function focusElement(element) {
	if (!element) {
		return;
	}

	element.focus();

	if (typeof element.select === 'function') {
		element.select();
	}
}

$.fn.jqueryPincodeAutotab = function (options = {}) {
	const $inputs = this;

	const settings = {
		prevElement: null,
		nextElement: null,
		defaultFlow: true,
		...options,
	};

	function getFocusableElements() {
		return Array.from(
			document.querySelectorAll(
				'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
			),
		).filter((element) => {
			return (
				element.offsetWidth > 0 ||
				element.offsetHeight > 0 ||
				element.getClientRects().length > 0
			);
		});
	}

	function focusPrevious(input, index) {
		const previousInput = $inputs.get(index - 1);

		if (previousInput) {
			focusElement(previousInput);
			return;
		}

		if (settings.prevElement) {
			focusElement($(settings.prevElement).get(0));
			return;
		}

		if (!settings.defaultFlow) {
			return;
		}

		const focusableElements = getFocusableElements();
		const currentIndex = focusableElements.indexOf(input);

		if (currentIndex > 0) {
			focusElement(focusableElements[currentIndex - 1]);
		}
	}

	function focusNext(input, index) {
		const nextInput = $inputs.get(index + 1);

		if (nextInput) {
			focusElement(nextInput);
			return;
		}

		if (settings.nextElement) {
			focusElement($(settings.nextElement).get(0));
			return;
		}

		if (!settings.defaultFlow) {
			return;
		}

		const focusableElements = getFocusableElements();
		const currentIndex = focusableElements.indexOf(input);

		if (currentIndex >= 0 && currentIndex < focusableElements.length - 1) {
			focusElement(focusableElements[currentIndex + 1]);
		}
	}

	$inputs.each(function (index) {
		const input = this;
		const $input = $(input);

		$input.on('keydown.pincodeAutotab', function (event) {
			const key = event.key;

			if (/^[0-9]$/.test(key)) {
				event.preventDefault();

				$input.val(key).trigger('change');
				focusNext(input, index);

				return;
			}

			switch (key) {
				case 'Backspace':
					event.preventDefault();

					if ($input.val()) {
						$input.val('').trigger('change');
					} else {
						focusPrevious(input, index);
					}
					break;

				case 'Delete':
					event.preventDefault();
					$input.val('').trigger('change');
					break;

				case 'Tab':
					event.preventDefault();

					if (event.shiftKey) {
						focusPrevious(input, index);
					} else {
						focusNext(input, index);
					}
					break;

				case 'ArrowLeft':
					event.preventDefault();
					focusPrevious(input, index);
					break;

				case 'ArrowRight':
					event.preventDefault();
					focusNext(input, index);
					break;

				case 'Enter':
					break;

				default:
					if (!event.ctrlKey && !event.metaKey) {
						event.preventDefault();
					}
					break;
			}
		});

		$input.on('input.pincodeAutotab', function () {
			const value = String($input.val() ?? '')
				.replace(/\D/g, '')
				.slice(-1);

			$input.val(value);

			if (value) {
				focusNext(input, index);
			}
		});

		$input.on('paste.pincodeAutotab', function (event) {
			event.preventDefault();

			const clipboardData =
				event.originalEvent?.clipboardData || window.clipboardData;

			if (!clipboardData) {
				return;
			}

			const pastedValue = clipboardData.getData('text').replace(/\D/g, '');

			if (!pastedValue) {
				return;
			}

			const digits = pastedValue.split('');
			let lastFilledIndex = index;

			digits.forEach((digit, offset) => {
				const targetIndex = index + offset;
				const targetInput = $inputs.get(targetIndex);

				if (!targetInput) {
					return;
				}

				$(targetInput).val(digit).trigger('change');
				lastFilledIndex = targetIndex;
			});

			const nextInput = $inputs.get(lastFilledIndex + 1);

			if (nextInput) {
				focusElement(nextInput);
			} else {
				focusNext($inputs.get(lastFilledIndex), lastFilledIndex);
			}
		});
	});

	return this;
};

export default $;
